module.exports = __webpack_public_path__ + "static/footer_logo-2e04f1392a4d659c22b442b9ee591829.png";